import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'

import FormAdvising from 'containers/Enrolment/form-advising'
import CoverModal from 'components/CoverModal'
import { requestAddSubjects } from 'containers/Enrolment/actions'
import { makeGetFilteredOfferings } from 'containers/Enrolment/selectors'

import ListOfferings from './list-offerings'
import ListEnrolled from './list-enrolled'

class FormContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showOfferings: false,
      showConfirm: false,
    }
  }

  _showOfferings = () => {
    this.setState({
      showOfferings: true,
    })
  }

  _hideOfferings = () => {
    this.setState({
      showOfferings: false,
    })
  }

  _requestAddSubjects = () => {
    const { dispatch, __selected } = this.props
    let checked = fromJS([])
    __selected.map((item) => {
      if (item.get('is_checked')) {
        checked = checked.push(item)
      }
      return true
    })

    if (checked.size > 0) {
      dispatch(requestAddSubjects(checked))
        .then((res) => {
          if (!res.error) {
            dispatch(actions.change('enrolledState', fromJS(res.payload)))
            this._hideOfferings()
          }
        })
    }
  }

  _renderOfferings() {
    const { showOfferings } = this.state
    if (!showOfferings) {
      return null
    }

    return (
      <CoverModal handleClose={this._hideOfferings} modalClass="subject">
        <ListOfferings
          handleClose={this._hideOfferings}
          onAdd={this._requestAddSubjects}
        />
      </CoverModal>
    )
  }

  render() {
    return (
      <div>
        <div className="m-b-20">
          <button onClick={this._showOfferings} type="button" className="btn btn-info">Subject Offerings</button>
        </div>
        <FormAdvising legend="Add/Withdraw Subjects" />
        <ListEnrolled />
        {this._renderOfferings()}
      </div>
    )
  }
}

FormContainer.propTypes = {
  __pending: PropTypes.bool,
  __selected: PropTypes.object,
}

function mapStateToProps(state) {
  const getSelected = makeGetFilteredOfferings()
  return {
    __pending: state.enrolment.get('pending'),
    __selected: getSelected(state),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/AddWithdraw/form-container.js